<template>
  <Head>
    <title>{{ job.title }} | Open CDL Jobs</title>
  </Head>
  <div class="mt-4 sm:mt-8">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 lg:col-span-8">
          <!-- <p
            v-if="job.sap"
            class="sm:mx-3 md:mx-0 mb-2 sm:mb-4 py-2 px-4 sm:rounded-md shadow border-t border-b sm:border-l sm:border-r border-blue-600 bg-blue-100 text-blue-900 text-sm font-semibold"
          >
            SAP drivers encouraged to apply!
          </p> -->

          <div class="p-4 sm:p-6 bg-white shadow sm:rounded-md">
            <!-- <p class="text-xs text-gray-500 font-medium">
              revised on {{ revisedOn || createdAt }}
            </p> -->
            <h3 class="mt-1 text-lg leading-6 font-medium text-gray-900">
              {{ job.title }}
            </h3>

            <!-- Revisit this section -->

            <p class="mt-1 text-sm text-gray-500 font-medium">
              Hiring in {{ job.properties.location }}
            </p>

            <div class="mt-4 border-t"></div>

            <div class="mt-4">
              <p class="flex items-center space-x-2">
                <span class="text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
                <span class="text-sm text-gray-600 font-medium">{{
                  job.company
                }}</span>
              </p>

              <p class="">
                <span class="text-2xl font-medium">{{
                  job.properties.salary
                }}</span>
              </p>
            </div>

            <div class="mt-8 space-y-2">
              <div class="text-sm" v-html="job.description"></div>
            </div>
          </div>
        </div>

        <div class="col-span-12 lg:col-span-4">
          <!-- The sticky doesn't play well with expanding and collapsing items -->
          <div>
            <div>
              <div class="space-y-4">
                <div class="px-4 py-4 bg-white shadow sm:rounded-md">
                  <div class="flex flex-col items-center space-y-2">
                    <a
                      ref="main-call-button"
                      v-if="job.properties.contact_phone"
                      target="_blank"
                      :href="`tel:${job.properties.contact_phone}`"
                      class="
                        flex
                        justify-center
                        items-center
                        w-full
                        sm:w-64
                        lg:w-full
                        space-x-2
                        bg-blue-500
                        text-white text-sm
                        font-medium
                        px-4
                        py-3
                        sm:py-2
                        rounded-md
                        shadow
                        hover:bg-blue-600
                        transition
                      "
                      id="main-apply-button"
                    >
                      <span>Call Now</span>
                      <span><PhoneIcon class="h-5 w-5" /></span>
                    </a>

                    <a
                      ref="main-apply-button"
                      v-if="job.properties.url_source"
                      target="_blank"
                      :href="job.properties.url_source"
                      class="
                        flex
                        justify-center
                        items-center
                        w-full
                        sm:w-64
                        lg:w-full
                        space-x-2
                        bg-blue-600
                        text-white text-sm
                        font-medium
                        px-4
                        py-3
                        sm:py-2
                        rounded-md
                        shadow
                        hover:bg-blue-700
                        transition
                      "
                    >
                      <span>Apply Now</span>
                      <span>
                        <ExternalLinkIcon class="h-5 w-5" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="mt-4 px-4 py-4 bg-white shadow sm:rounded-md">
                <h3 class="text-sm font-medium">Share Job</h3>
                <div class="mt-2 space-x-2">
                  <a
                    class="inline-flex p-2 rounded-md hover:shadow"
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${shareableUrl}`"
                    target="_blank"
                    rel="noopener"
                  >
                    <FacebookIcon class="inline-block h-6 w-6" />
                  </a>

                  <button
                    @click="copyShareableUrl"
                    type="button"
                    class="inline-flex p-2 rounded-md hover:shadow"
                  >
                    <ShareIcon class="inline-block h-6 w-6" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <template>
    <a
      ref="mobile-apply-button"
      class="
        sm:invisible
        fixed
        bottom-8
        right-8
        px-6
        py-3
        flex
        items-center
        justify-center
        space-x-2
        bg-blue-600
        text-sm
        font-medium
        text-white
        hover:bg-blue-700
        rounded-full
        shadow
        transition
      "
      :href="job.properties.url_source"
      target="_blank"
    >
      <span>Apply Now</span>
      <ExternalLinkIcon class="h-5 w-5" />
    </a>
    <a
      ref="mobile-call-button"
      class="
        sm:hidden sm:invisible
        fixed
        right-8
        mb-2
        px-6
        py-3
        flex
        items-center
        justify-center
        space-x-2
        bg-blue-500
        text-sm
        font-medium
        text-white
        hover:bg-blue-600
        rounded-full
        shadow
        transition
      "
      :class="job.properties.url_source ? 'bottom-20' : 'bottom-8'"
      :href="`tel:${job.properties.contact_phone}`"
      v-show="job.properties.contact_phone"
    >
      <span>Call Now</span>
      <PhoneIcon class="h-5 w-5" />
    </a>
  </template>

  <transition
    enter-from-class="transform translate-y-full opacity-0"
    leave-to-class="transform translate-y-full opacity-0"
    leave-from-class="transform translate-y-0 opacity-100"
    enter-to-class="transform translate-y-0 opacity-100"
    enter-active-class="transition duration-150"
    leave-active-class="transition duration-100"
  >
    <div
      v-if="copied"
      class="
        fixed
        bottom-4
        inset-x-6
        max-w-sm
        mx-auto
        bg-white bg-opacity-90
        rounded
        px-4
        py-3
        text-center
        font-medium
        text-sm
        border border-gray-300
      "
    >
      Link copied to clipboard!
    </div>
  </transition>
</template>

<script>
import inViewport from "in-viewport";
import { DateTime } from "luxon";
import { ShareIcon } from "@heroicons/vue/outline";
import {
  CheckCircleIcon,
  ExternalLinkIcon,
  PhoneIcon,
  XCircleIcon,
} from "@heroicons/vue/solid";
import { Head } from "@inertiajs/inertia-vue3";
import {
  FacebookIcon,
  FlaskIcon,
  TwitterIcon,
  TruckIcon,
} from "@/components/Icons";
import InfoCard from "@/components/Jobs/InfoCard";

export default {
  props: {
    job: Object,
  },

  data: () => ({
    copied: false,
  }),

  created() {
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "JobPosting",
      datePosted: DateTime.fromISO(
        this.job.revised_on || this.job.created_at
      ).toISODate(),
      validThrough: DateTime.fromISO(this.job.end_date),
      description: this.job.description,
      hiringOrganization: {
        "@type": "Organization",
        name: this.job.company,
        sameAs: this.job.properties.url_source,
      },
      jobLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          addressCountry: "US",
          addressLocality: this.job.properties.city,
          addressRegion: this.job.properties.state,
        },
      },
      title: this.job.title,
      baseSalary: {
        "@type": "MonetaryAmount",
        currency: "USD",
        value: {
          "@type": "QuantitativeValue",
          value: this.job.properties.salary,
          unitText: "WEEK",
        },
      },
      identifier: {
        "@type": "PropertyValue",
        name: this.job.company,
        value: this.job.reference,
      },
      employmentType: this.job.properties.employment_type,
    };

    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
  },

  mounted() {
    const mainApplyButton = this.$refs["main-apply-button"];
    const mainCallButton = this.$refs["main-call-button"];
    const mobileApplyButton = this.$refs["mobile-apply-button"];
    const mobileCallButton = this.$refs["mobile-call-button"];

    document.addEventListener(
      "scroll",
      function () {
        if (inViewport(mainApplyButton)) {
          mobileApplyButton.style.transform = "translateY(100%)";
          mobileApplyButton.style.opacity = 0;
        } else if (inViewport(mainCallButton)) {
          mobileCallButton.style.transform = "translateY(100%)";
          mobileCallButton.style.opacity = 0;
        } else {
          if (mobileApplyButton) {
            mobileApplyButton.style.transform = "translateY(0)";
            mobileApplyButton.style.opacity = 1;
          }
          if (mobileCallButton) {
            mobileCallButton.style.transform = "translateY(0)";
            mobileCallButton.style.opacity = 1;
          }
        }
      },
      {
        passive: true,
      }
    );
  },

  computed: {
    shareableUrl() {
      return window.location.href;
    },
  },

  methods: {
    copyShareableUrl() {
      navigator.clipboard
        .writeText(this.shareableUrl)
        .then(() => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 3000);
        })
        .catch((err) => {});
    },
  },

  components: {
    CheckCircleIcon,
    ExternalLinkIcon,
    FacebookIcon,
    FlaskIcon,
    Head,
    PhoneIcon,
    ShareIcon,
    TruckIcon,
    TwitterIcon,
    XCircleIcon,
    InfoCard,
  },
};
</script>
